import React, { useState, useEffect } from "react";
import EmailIcon from '../../../assets/images/Union.svg';
import { Image } from "../../../components/componentIndex";
import { Button, Input, CheckedImage, Select } from '../../../common/commonIndex';
import EmailService from '../../../services/API/emailService';
import { toast } from "react-toastify";

const StepEmail = ({ handleNextEvent, formData, getPersonalInfo, updatePersonalInfo, currentUser, countryCodes }) => {
  const [email, setEmail] = useState(formData.email);
  const [isValid, setIsValid] = useState(false);
  const [isError, setIsError] = useState(true);

  const [selectedCountry, setSelectedCountry] = useState('+1');
  const [mobileNumber, setMobileNumber] = useState(formData.mobileNumber || '');
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [isSubmit, setIsSubmit] = useState(true);
  const phoneRegex = /^[0-9]{10,}$/;

  useEffect(() => {
    if (formData?.email) {
      setEmail(formData?.email);
      setIsValid(validateEmail(formData?.email));
    } else {
      setEmail();
      setIsValid(false);
    }
    formData.email = localStorage.getItem('emailAddress');
  });

  // Function to validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  // Handle email input change
  const handleEmailChange = (e) => {
    const value = e;
    setEmail(value);
    if (!isError) {
      setIsError(validateEmail(email));
    }
    setIsValid(validateEmail(value));
    formData.email = value;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData?.magicToken && formData?.magicToken !== '') {
      if (formData?.mobileNumber?.trim() !== '' && formData?.mobileNumber?.length === 10) {
        setIsMobileValid(true);
      } else {
        setIsMobileValid(false);
      }
      if (!isMobileValid) {
        return;
      }
      updatePersonalInfo(formData);
      handleNextEvent(3);
    } else {
      setIsError(validateEmail(email));
      if (!validateEmail(email)) {
        return;
      }
      // Call Api Add Email To Phone
      try {
        const emailRequest = { NewEmail: email, AccessToken: currentUser?.access_token };
        const response = await EmailService.addEmailByPhone(emailRequest, currentUser?.token);
        if (response?.statusCode === 200) {
          // handleNextEvent(3);
          if (formData?.email && formData?.firstName && formData?.lastName && formData?.sex && formData?.day && formData?.month && formData?.year) {
            updatePersonalInfo(formData);
          } else {
            handleNextEvent(3);
          }
        }
        return response;
      } catch (error) {
        console.error(error);
      }
    }

  };

  const handleCountryChange = (key, value) => {
    setSelectedCountry(value);
    formData[key] = value;
  };
  const handleInputChange = (key, value) => {
    if (key === 'mobileNumber') {
      setMobileNumber(value);
      if (value?.trim() !== '' && value?.length === 10) {
        setIsMobileValid(true);
      } else {
        setIsMobileValid(false);
      }
    }
    formData[key] = value;
  };


  return (
    <div className="email-form-container">
      <h2 className="title">Enter your email</h2>
      <p className="sub-title my-4">We’ll use this to verify your identity and send you important updates.</p>

      <form onSubmit={handleSubmit}>
        {formData?.magicToken && formData?.magicToken !== '' ? (
          <div className="input-group">
            <Select
              defaultValue={selectedCountry}
              list={countryCodes}
              value={formData?.countryCodes}
              className={'bg-transparent'}
              onChange={(value) => handleCountryChange('countryCodes', value)}
            />
            <div className='line'></div>
            <Input
              inputType={'text'}
              inputPlaceholder={'Mobile number'}
              className={'form-control'}
              required={true}
              isPhoneNumber={true}
              value={formData?.mobileNumber}
              onChange={(value) => handleInputChange('mobileNumber', value)}
            />
            {phoneRegex.test(mobileNumber) && <CheckedImage />}
          </div>
        ) : (
          <div className={`input-group ${isValid ? 'valid' : ''} `}>
            <Image imgUrl={EmailIcon} altText="Email" />
            <Input inputType={'email'} inputPlaceholder={'Email'}
              className={'form-control'}
              required={true}
              value={email}
              name={'email1'}
              onChange={handleEmailChange}
            />
            {isValid && (
              <CheckedImage />
            )}
          </div>
        )}

        {/* {!isError && ( */}
        <div className="error-content">
          <p className="is-error ">{!isError ? email?.trim() !== '' ? 'Invalid email format' : 'Email is required' : ''}</p>
        </div>
        {/* )} */}
        <p className="security-text mb-5 mx-auto">You can verify your email now, or choose to do so later.</p>
        <Button
          btnClass={'btn-primary'}
          btnType={'submit'}
          btnName={'Next'}
          onClick={handleSubmit}
          isDisabled={true}
        />
      </form>
    </div>
  );
};

export default StepEmail;
